import { incrementNumberOrStringAsNumber } from '~/cynqueModules/utils/incrementNumberOrStringAsNumber'

export function getNextVersionNumberString(
  currentVersionNumber: string | undefined
): string {
  return incrementNumberOrStringAsNumber(currentVersionNumber).toString()
}
